<template>
  <div class="secKillPage">
    <div class="sellLogin-header">当前账号：{{ userInfo.nick_name }}
      <span @click="handleLogin">【点击切换】</span>
    </div>
    <img class="img" :src="imgUrl" />
    <van-count-down class="nowTime" :time="nowTime" />
    <span class="stock">库存剩余:<span class="val">{{ nowStock }}</span>件</span>
    <div class="footer" @click="placeAnOrder(pid)">
      <img class="img" src="@/assets/images/sellCard/secKillBtn.png">
    </div>
    <!--弹出层-->
    <van-overlay :show="noStockShow" @click="noStockShow = false">
      <div class="wrapper">
        <img class="img" src="@/assets/images/sellCard/secKillDialog.png" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'secKillPage',
  props: ['userInfo', 'source'],
  data () {
    return {
      nowStock: 0,
      pid: '',
      imgUrl: require('@/assets/images/sellCard/secKillYinHe.jpg'),
      noStockShow: false
    }
  },
  computed: {
    nowTime () {
      // let date = new Date()
      // date.setHours(0, 0, 0, 0)
      // const endTime = new Date('2022-06-20 24:00:00')
      const endTime = new Date('2022/09/26 23:59:59')
      let nowDate = new Date()
      return endTime.getTime() - nowDate.getTime()
      // return 24 * 3600 * 1000 - (nowDate.getTime() - date.getTime())
    }
  },
  created () {
    if (this.source === 'yinhe') {
      this.pid = process.env.VUE_APP_msYinHeId
      this.imgUrl = require('@/assets/images/sellCard/secKillYinHe.jpg')
    } else {
      this.pid = process.env.VUE_APP_msTenCentId
      this.imgUrl = require('@/assets/images/sellCard/tencentSecKill.jpg')
    }
  },
  mounted () {
    this.initStock(this.pid)
  },
  methods: {
    initStock (pid) {
      this.$service.getProductDetail(pid).then(res => {
        if (res.totalCount > 5) {
          this.nowStock = parseInt(res.totalCount / 5)
        } else if (res.totalCount < 0) {
          this.nowStock = 0
        } else {
          this.nowStock = res.totalCount
        }
      })
    },
    isIOS () {
      var u = navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      return isIOS
    },
    placeAnOrder (pid) {
      if (this.nowTime <= 0) {
        this.$toast('活动已结束!')
        return
      }
      if (this.isIOS()) {
        this.$toast('只能用安卓手机进行抢购!')
        return
      }
      // 增加曝光埋点
      const data = {
        login_type: localStorage.getItem('loginType'),
        open_id: this.userInfo.open_id,
        scenario: '普通支付',
        vip_name: this.source === 'yinhe' ? '爱奇艺VIP专属秒杀' : '腾讯VIP专属秒杀',
        vip_duration: '1天',
        scanTool: '微信',
        page_name: '公众号专属秒杀',
        button_name: '秒杀抢购'
      }
      if (this.source === 'yinhe') {
        window._cooc.push(['_trackEvent', 'ms_aiqiyi_stock_vip', '点击', data])
      } else {
        window._cooc.push(['_trackEvent', 'ms_tencent_stock_vip', '点击', data])
      }
      if (this.nowStock > 0) {
        this.$service.placeAnOrder(pid).then(res => {
          if (res.code === 500) {
            this.$constants.onLogin()
          } else if (res.code === 501) {
            this.$constants.onLogin('weixin,qq')
          } else {
            window.location.href = res.url
          }
        })
      } else {
        this.noStockShow = true
      }
    },
    handleLogin () {
      this.$emit('handleLogin')
    }
  }
}
</script>

<style lang="stylus" scoped>
.secKillPage
  position relative
  .sellLogin-header
    line-height 22px
    font-size 12px
    background linear-gradient(90deg, #4a24b5, #a73cda)
    color #fff
    padding 5px
  .img
    width 100%
  .nowTime, .stock
    position absolute
    top 537px
    left 75px
    font-size 21px
    color #242222
  .stock
    left 205px
    font-size 13px
    color #f25b5b
    text-align center
    .val
      display inline-block
      min-width 20px
  .footer
    padding 10px 20px
    position fixed
    bottom 0
    left 0
    right 0
    // background #4939d2
  .wrapper {
    display flex
    align-items center
    justify-content center
    height 100%
    padding 0 20px
  }
</style>
